import { IndividualQuota } from '../../../shared/interfaces/quota.interface';

export class IndividualQuotas {
  private get _quotas(): IndividualQuota[] {
    return this._individualQuotas || [];
  }
  constructor(private readonly _individualQuotas: IndividualQuota[]) {}

  public allocation(): number {
    return this._quotas.reduce(
      (count, q) => count + (q.allocation?.quantity || 0),
      0
    );
  }

  public percentage(): number {
    return this._quotas.reduce(
      (count, q) => count + (q.allocation?.percentage || 0),
      0
    );
  }
}
